var _rect, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCcJcbDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 32,
    viewBox: "0 0 47 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45.6667,
    height: 31,
    rx: 3.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7571 16.3829C30.442 16.3978 31.1308 16.3526 31.813 16.4063C32.5038 16.5352 32.6703 17.581 32.0566 17.9235C31.6378 18.1492 31.1403 18.0076 30.6863 18.0474H29.7571V16.3829V16.3829ZM32.209 14.4988C32.3612 15.0359 31.8434 15.5182 31.3261 15.4442H29.7571C29.7681 14.9377 29.7356 14.388 29.7731 13.9081C30.4016 13.9258 31.0359 13.872 31.6608 13.9362C31.9293 14.0037 32.154 14.2244 32.209 14.4988V14.4988ZM35.985 6.53373C36.0141 7.55946 35.9892 8.63941 35.9975 9.68596C35.9956 13.9408 36.0017 18.1956 35.9942 22.4507C35.9667 24.0453 34.5535 25.4309 32.9699 25.4627C31.3848 25.4691 29.7994 25.4637 28.2141 25.4654V19.033C29.9414 19.0241 31.6696 19.0511 33.3961 19.0195C34.1971 18.9692 35.0744 18.4407 35.1117 17.5593C35.206 16.674 34.3714 16.0617 33.579 15.965C33.2744 15.9571 33.2833 15.8762 33.579 15.841C34.3348 15.6776 34.9283 14.8954 34.7059 14.112C34.5164 13.2881 33.6057 12.9692 32.8483 12.9708C31.3038 12.9603 29.759 12.9693 28.2145 12.9662C28.2244 11.7654 28.1936 10.5632 28.231 9.36325C28.3534 7.79742 29.8022 6.50612 31.3635 6.53414C32.9042 6.5339 34.4446 6.5339 35.985 6.53385V6.53373Z",
    fill: "url(#paint0_linear_1909_22324)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7608 9.52571C10.8003 7.93363 12.2195 6.5594 13.801 6.53613C15.3803 6.53127 16.9598 6.53543 18.539 6.53402C18.5347 11.8608 18.5476 17.1882 18.5325 22.5147C18.4717 24.0874 17.0679 25.4354 15.5036 25.4633C13.9214 25.469 12.3389 25.4641 10.7566 25.4657V18.8164C12.2936 19.1794 13.9053 19.334 15.4732 19.0932C16.4105 18.9424 17.4359 18.4821 17.7532 17.5098C17.9867 16.678 17.8553 15.8027 17.89 14.949V12.9665H15.1766C15.1644 14.2777 15.2015 15.5912 15.1569 16.9007C15.0838 17.7057 14.2866 18.2171 13.5274 18.1898C12.5859 18.1998 10.7202 17.5075 10.7202 17.5075C10.7155 15.0509 10.7475 11.9744 10.7608 9.52595V9.52571Z",
    fill: "url(#paint1_linear_1909_22324)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5508 13.766C19.4079 13.7963 19.522 13.2795 19.4855 13.0834C19.4953 11.8438 19.4652 10.6029 19.5021 9.36413C19.6241 7.79168 21.084 6.49716 22.6517 6.53397H27.2683C27.2639 11.8607 27.2768 17.1881 27.2617 22.5146C27.2009 24.0873 25.797 25.4353 24.2326 25.4632C22.6503 25.4692 21.0679 25.4642 19.4855 25.4657V18.1804C20.5662 19.0672 22.035 19.2052 23.3814 19.2076C24.3964 19.2072 25.4055 19.0507 26.3912 18.8167V17.482C25.2803 18.0356 23.9745 18.3873 22.7431 18.0692C21.8841 17.8554 21.2606 17.0252 21.2745 16.1388C21.175 15.2169 21.7153 14.2436 22.6213 13.9695C23.746 13.6174 24.9719 13.8867 26.0263 14.3445C26.2521 14.4628 26.4814 14.6095 26.3911 14.2319V13.1829C24.6278 12.7633 22.7512 12.609 20.9797 13.0654C20.4669 13.21 19.9673 13.4294 19.5508 13.7661V13.766Z",
    fill: "url(#paint2_linear_1909_22324)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1909_22324",
    x1: 28.161,
    y1: 15.5948,
    x2: 35.9485,
    y2: 15.5948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B03A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55B330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1909_22324",
    x1: 10.5911,
    y1: 16.1811,
    x2: 18.4114,
    y2: 16.1811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F6EB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1909_22324",
    x1: 19.4741,
    y1: 15.7784,
    x2: 27.2668,
    y2: 15.7784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30138"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcJcbDefault);
export default __webpack_public_path__ + "static/media/cc_jcb_default.9e494dc59f7ad0de3870a6bad80a76ce.svg";
export { ForwardRef as ReactComponent };